var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal-action-" + _vm.action,
          attrs: {
            id: "modal-action-" + _vm.action,
            title: _vm.title + " documento",
            "ok-title": _vm.title,
            "cancel-title": "Cancelar",
            "no-close-on-backdrop": "",
            size: "lg",
            centered: ""
          },
          on: { ok: _vm.commitAction, cancel: _vm.cancelProcess }
        },
        [
          _c("div", { staticClass: "-mt-2" }, [
            _c(
              "form",
              {
                staticClass: "mt-4",
                attrs: {
                  "data-vv-scope": "sign-document",
                  autocomplete: "off"
                },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-3" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("SignaturesContainer", {
                          attrs: {
                            signatures: _vm.signatures,
                            placeholder: "Buscar Firma"
                          },
                          model: {
                            value: _vm.signatureSelected,
                            callback: function($$v) {
                              _vm.signatureSelected = $$v
                            },
                            expression: "signatureSelected"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm.selectedFile &&
                  _vm.fileOnFlow.detalle.documentosBase &&
                  _vm.fileOnFlow.detalle.documentosBase.length
                    ? _c(
                        "div",
                        { staticClass: "col-9" },
                        [
                          _c("PdfViewport", {
                            attrs: {
                              "default-page": 1,
                              s3url: _vm.selectedFile.url,
                              name:
                                _vm.fileOnFlow.detalle.documentosBase[0]
                                  .objetoNombre,
                              signatures: Object.values(
                                _vm.step.signaturesDropped
                              ),
                              "closable-sign": true,
                              "signature-width": _vm.signatureWidth,
                              "signature-height": _vm.signatureHeight,
                              "signature-type": _vm.signatureType
                            },
                            on: {
                              loaded: function($event) {
                                return _vm.$emit("loaded")
                              },
                              "page-click": _vm.onSignatureDropped,
                              "signature-delete": _vm.onSignatureDelete,
                              "signature-drag-end": _vm.onSignatureDragEnd
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }